import ReactDOM from "react-dom";
import React, { useState, useContext, useEffect } from "react";
import objects from "../../objects";
import "./Instrukcja.scss";
import "../Button/Button.scss";
import grass from "../../assets/tr1.jpg";
import tree_mini from "../../assets/trees/grupa_tree.png";
import arrow from "../../assets/rarr.svg";
import arrow_orange from "../../assets/larr.svg";
import { BuildingsContext } from "../../bContext";

import back1 from "../../assets/back11.png"
import back1En from "../../assets/back11en.png"
import back2 from "../../assets/back22.png"
import back2En from "../../assets/back22en.png"
import back3 from "../../assets/back33.png"
import back3En from "../../assets/back33en.png"
import back4 from "../../assets/back44.png"
import back4En from "../../assets/back44en.png"

import PageOne from "./Pages/PageOne";
import PageTwo from "./Pages/PageTwo";
import PageThree from "./Pages/PageThree";
import PageFour from "./Pages/PageFour";
import PageFive from "./Pages/PageFive";
import PageSix from "./Pages/PageSix";
import PageSeven from "./Pages/PageSeven";
import PageEight from "./Pages/PageEight";
import PageNine from "./Pages/PageNine";
import PageTen from "./Pages/PageTen";
import PageEleven from "./Pages/PageEleven";
import PageTwelve from "./Pages/PageTwelve";
import PageThirteen from "./Pages/PageThirteen";
import PageFourteen from "./Pages/PageFourteen";
import PageFifteen from "./Pages/PageFifteen";

const Instrukcja = ({ isShowing, hide, props }) => {
  const { which, setWhich, modalPage, setModalPage, setIsOn , isOn , setPlayMusic, setPageRoad, switchToEnglish} = useContext(
    BuildingsContext
  );
  const [anime, setAnime] = useState(0);
  const [page, setPage] = useState(0);
  const [left, setLeft] = useState(0);
  const [right, setRight] = useState(0);

  const animateLeft = () => {
    // Button begins to shake
    setAnime(1);

    // Buttons tops to Anime after 2 seconds
    setTimeout(() => setAnime(0), 700);
  };

  const animateRight = () => {
    // Button begins to shake
    setAnime(2);

    // Buttons tops to Anime after 2 seconds
    setTimeout(() => setAnime(0), 700);
  };

 

  return isShowing
    ? ReactDOM.createPortal(
        <React.Fragment>
          <div className="modal-overlay-ins" />
          <div className="modal-wrapper-ins">
            <div className="mini-header-ins">
              <h3>{switchToEnglish === false ?  "INSTRUKCJA" : "INSTRUCTION"}</h3>
              
            </div>

            <div
              onClick={() => {
                hide();
                setPage(0);
                setPlayMusic(true)
                setPageRoad(0)
              }}
              className="mini-exit"
            >
              <svg
                className="xsvg"
                height="365.696pt"
                viewBox="0 0 365.696 365.696"
                width="365.696pt"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="m243.1875 182.859375 113.132812-113.132813c12.5-12.5 12.5-32.765624 0-45.246093l-15.082031-15.082031c-12.503906-12.503907-32.769531-12.503907-45.25 0l-113.128906 113.128906-113.132813-113.152344c-12.5-12.5-32.765624-12.5-45.246093 0l-15.105469 15.082031c-12.5 12.503907-12.5 32.769531 0 45.25l113.152344 113.152344-113.128906 113.128906c-12.503907 12.503907-12.503907 32.769531 0 45.25l15.082031 15.082031c12.5 12.5 32.765625 12.5 45.246093 0l113.132813-113.132812 113.128906 113.132812c12.503907 12.5 32.769531 12.5 45.25 0l15.082031-15.082031c12.5-12.503906 12.5-32.769531 0-45.25zm0 0" />
              </svg>
            </div>
            {modalPage === 1 && (
              <div className="modal">
                <PageOne />

                <div className="ins-btn">
                  {/* <div class="slick-prev slick-arrow "></div> */}
                  <img
                    className={
                      modalPage === 1 ? "arrow_left opa" : "arrow_left"
                    }
                    src={left === 1 ? arrow_orange : arrow}
                    alt="arrow"
                    onMouseOver={() =>
                      modalPage === 1 ? setLeft(0) : setLeft(1)
                    }
                    onMouseLeave={() => setLeft(0)}
                    onClick={() =>
                      modalPage <= 1 ? 1 : setModalPage(modalPage - 1)
                    }
                  />
                  <p>{`${modalPage}`}/15</p>
                  {/* <div class="slick-next slick-arrow "></div> */}
                  <img
                    className={modalPage === 15 ? "opa" : "arrows"}
                    src={right === 1 ? arrow_orange : arrow}
                    alt="arrow"
                    onMouseOver={() =>
                      modalPage === 15 ? setRight(0) : setRight(1)
                    }
                    onMouseLeave={() => setRight(0)}
                    onClick={() =>
                      {
                        setPlayMusic(true);
                        if ( modalPage >= 15){
                         return 15
                        } else {
                          setModalPage(modalPage + 1);
                        }
                   
                      
                    }
                    }
                  />
                  <div className="borderLeft"></div>
                </div>
              </div>
            )}

            {modalPage >= 2 && modalPage <= 8 && (
              <div className="modal2">
                {modalPage === 2 && <PageTwo />}
                {modalPage === 3 && <PageThree />}
                {modalPage === 4 && <PageFour />}
                {modalPage === 5 && <PageFive />}
                {modalPage === 6 && <PageSix />}
                {modalPage === 7 && <PageSeven />}
                {modalPage === 8 && <PageEight />}

                <div className="back_pwik backpw" style={{backgroundImage: !switchToEnglish ? `url(${back1})` : `url(${back1En})`  }}></div>
                <div className="ins-btn">
                  {/* <div class="slick-prev slick-arrow "></div> */}
                  <img
                    className={
                      modalPage === 1 ? "arrow_left opa" : "arrow_left"
                    }
                    src={left === 1 ? arrow_orange : arrow}
                    alt="arrow"
                    onMouseOver={() =>
                      modalPage === 1 ? setLeft(0) : setLeft(1)
                    }
                    onMouseLeave={() => setLeft(0)}
                    onClick={() =>
                      modalPage <= 1 ? 1 : setModalPage(modalPage - 1)
                    }
                  />
                  <p>{`${modalPage}`}/15</p>
                  {/* <div class="slick-next slick-arrow "></div> */}
                  <img
                    className={modalPage === 15 ? "opa" : "arrows"}
                    src={right === 1 ? arrow_orange : arrow}
                    alt="arrow"
                    onMouseOver={() =>
                      modalPage === 15 ? setRight(0) : setRight(1)
                    }
                    onMouseLeave={() => setRight(0)}
                    onClick={() =>
                      modalPage >= 15 ? 15 : setModalPage(modalPage + 1)
                    }
                  />
                  <div className="borderLeft"></div>
                </div>
              </div>
            )}
            {modalPage >= 9 && modalPage <= 15 && (
              <div className="modal2">
                {modalPage === 9 && <PageNine />}
                {modalPage === 10 && <PageTen />}
                {modalPage === 11 && <PageEleven />}
                {modalPage === 12 && <PageTwelve />}
                {modalPage === 13 && <PageThirteen />}
                {modalPage === 14 && <PageFourteen />}
                {modalPage === 15 && <PageFifteen />}
              {modalPage >=9 && modalPage < 14 && <div className="back_pwik2" style={{backgroundImage: !switchToEnglish ? `url(${back2})` : `url(${back2En})`  }}></div>}
              {modalPage === 14 && <div className="back_pwik3" style={{backgroundImage: !switchToEnglish ? `url(${back3})` : `url(${back3En})`  }}></div> }
              {modalPage === 15 && <div className="back_pwik4" style={{backgroundImage: !switchToEnglish ? `url(${back4})` : `url(${back4En})`  }}></div> }
                
                
                
                <div className="ins-btn">
                  {/* <div class="slick-prev slick-arrow "></div> */}
                  <img
                    className={
                      modalPage === 1 ? "arrow_left opa" : "arrow_left"
                    }
                    src={left === 1 ? arrow_orange : arrow}
                    alt="arrow"
                    onMouseOver={() =>
                      modalPage === 1 ? setLeft(0) : setLeft(1)
                    }
                    onMouseLeave={() => setLeft(0)}
                    onClick={() =>
                      modalPage <= 1 ? 1 : setModalPage(modalPage - 1)
                    }
                  />
                  <p>{`${modalPage}`}/15</p>
                  {/* <div class="slick-next slick-arrow "></div> */}
                  <img
                    className={modalPage === 15 ? "opa" : "arrows"}
                    src={right === 1 ? arrow_orange : arrow}
                    alt="arrow"
                    onMouseOver={() =>
                      modalPage === 15 ? setRight(0) : setRight(1)
                    }
                    onMouseLeave={() => setRight(0)}
                    onClick={() =>
                      modalPage >= 15 ? 15 : setModalPage(modalPage + 1)
                    }
                  />
                  <div className="borderLeft"></div>
                </div>
              </div>
            )}
          </div>
        </React.Fragment>,
        document.body
      )
    : null;
};

export default Instrukcja;
